import type { StateCreator } from 'zustand';

export interface UserSlice {
  credits: number;
  setCredits: (credits: number) => void;
  isCreditsLoading: boolean;
  setIsCreditsLoading: (loading: boolean) => void;
  areCreditsAvailable: boolean | null;
  setAreCreditsAvailable: (available: boolean | null) => void;
}

export const userInitialState = {
  credits: 0,
  isCreditsLoading: false,
  areCreditsAvailable: null as boolean | null,
};

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (
  set
) => ({
  ...userInitialState,

  setCredits: (credits) => set({ credits }),
  setIsCreditsLoading: (isCreditsLoading) => set({ isCreditsLoading }),
  setAreCreditsAvailable: (areCreditsAvailable) => set({ areCreditsAvailable }),
});
